import React from 'react';
import { Search, Bell } from 'lucide-react';
import { motion } from 'framer-motion';

const AdminHeader = ({ user }) => {
    return (
        <header className="bg-white h-24 px-10 flex items-center justify-between border-b border-agro-green-light/10">
            {/* Welcome Message */}
            <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
            >
                <h1 className="text-2xl font-serif text-agro-black">G'day, {user?.name?.split(' ')[0] || 'Admin'}</h1>
                <p className="text-xs text-agro-green/60 mt-1 font-bold uppercase tracking-widest">Harvesting success today</p>
            </motion.div>

            {/* Right Side Actions */}
            <div className="flex items-center space-x-6">
                {/* Search Bar */}
                <div className="relative hidden md:block">
                    <Search className="h-4 w-4 text-agro-green/30 absolute left-4 top-1/2 transform -translate-y-1/2" />
                    <input
                        type="text"
                        placeholder="Search dashboard..."
                        className="pl-12 pr-6 py-3 bg-agro-green-light/5 border border-agro-green-light/10 rounded-2xl text-sm text-agro-green-dark focus:ring-2 focus:ring-agro-green-light/20 w-72 transition-all outline-none"
                    />
                </div>

                {/* Notifications */}
                <button className="relative p-3 bg-agro-green-light/5 text-agro-green-dark hover:bg-agro-green-light/10 rounded-2xl transition-all">
                    <Bell className="h-5 w-5" />
                    <span className="absolute top-3 right-3 h-2 w-2 bg-agro-lime rounded-full border-2 border-white"></span>
                </button>

            </div>
        </header>
    );
};

export default AdminHeader;
